import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
import * as XLSX from "xlsx";
import { Table, Button, Space, Modal, Card, Row, Col, Typography } from "antd";
import { EditOutlined, DeleteOutlined, EyeOutlined, EnvironmentOutlined, FilePdfOutlined, FileExcelOutlined } from "@ant-design/icons";
import Paginate from "../../components/Paginate/Paginate";
import CustomLoader from "../../components/Loading/TopBarLoader";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import PdfPage from "../../actions/pdf_part/PdfPage";
import { ShimmerPostList } from "react-shimmer-effects";
import PelakComponent from "../../components/Pelak/pelakComponent";
import { deleteCargo } from "../../actions/cargo/cargo";

const { Text } = Typography;

export default function ReportListPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJens, setSelectedJens] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [paging, setPaginate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingExport, setLoadingExport] = useState(false);
  const [loadingExportPdf, setLoadingExportPdf] = useState(false);
  const [searchParams] = useSearchParams();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const navigate = useNavigate();
  const payload = localStorage.getItem('reportPayload');

  const handleOpenModal = (jensList) => {
    setSelectedJens(jensList);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedJens([]);
  };

  useEffect(() => {
    if (payload) {
      const params = new URLSearchParams(searchParams);
      const fetchData = async () => {
        try {
          const token = Cookies.get('login_token');
          setLoading(true);
          const parsedPayload = JSON.parse(payload);

          params.forEach((value, key) => {
            parsedPayload[key] = value;
          });

          const response = await axios.post(`${process.env.REACT_APP_API_URL}/ReportWeb/Reports/store`, parsedPayload,
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
          setReportData(response.data.data);
          setPaginate(response.data.meta.links);
          setLoading(false);
        } catch (error) {
          if (axios.isAxiosError(error)) {
            const axiosError = error;
            if (axiosError.response && axiosError.response.status === 401) {
              toast.error('نشست منقضی شده !');
              navigate('/authentication/sign-in')
            }
            return {
              status: 'error',
              message: axiosError.message || 'خطا در اتصال به سرور'
            };
          }
          toast.error('خطا در دریافت اطلاعات!');
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [searchParams, payload, navigate]);

  const fetchAllReport = async () => {
    if (payload) {
      try {
        setLoadingExport(true);
        const token = Cookies.get('login_token');
        const parsedPayload = JSON.parse(payload);
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/ReportWeb/Reports/all`, parsedPayload,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
        setLoadingExport(false);

        const data = response.data.data.map((item) => ({
          "تاریخ و ساعت": item.date || "",
          "شماره حواله": item.cargo_code || "",
          "پیمانکار": item.peymankar?.name || "",
          "پروژه": item.project?.title || "",
          "محل استقرار": item.location?.name || "",
          "دستگاه": item.machine?.name || "",
          "نوع دستگاه": item.machine?.type || "",
          "شیفت": item.shift?.name || "",
          "نقص فنی": item.defect?.name || "",
          "تاخیر": item.delays?.name || "",
          "تراز": item.balance || "",
          "راننده": item.driver?.name || "",
          "مدت زمان عملیات": item.duration || "",
          "کرایه": item.amount_with || "",
          "هزینه کل عملیات": item.sum_amount_with || "",
          "کالا": (item.jens || [])
            .map(
              (subItem, index) =>
                `کالا: ${subItem['defination']?.['title'] || 'نامشخص'}، کد کالا: ${
                  subItem['jens_code']?.['title'] || 'نامشخص'
                }، تعداد: ${subItem['jens_unit'] || 'نامشخص'}، شماره کالا: ${
                  subItem['jens_number'] || 'نامشخص'
                }، واحد: ${subItem['weight']?.['title'] || 'نامشخص'}، وزن: ${
                  subItem['weight_unit'] || 'نامشخص'
                }`
            )
            .join("\n"),
          "مبدا": item.origin?.title || "",
          "مقصد": item.destination?.title || "",
          "تجهیز بارگیری": item.equipment?.name || "",
          "اپراتور": item.operator?.name || "",
          "نام مسئول عملیات": item.user?.name || "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "گزارش");
        XLSX.writeFile(workbook, 'گزارشات-بارگو.xlsx');
      } catch (error) {
        setLoadingExport(false);
        if (axios.isAxiosError(error)) {
          const axiosError = error;
          if (axiosError.response && axiosError.response.status === 401) {
            toast.error('نشست منقضی شده !');
            navigate('/authentication/sign-in')
          }
          return {
            status: 'error',
            message: axiosError.message || 'خطا در اتصال به سرور'
          };
        }
        toast.error('خطا در دریافت اطلاعات!');
      }
    }
  };

  const exportToExcel = async () => {
    if (selectedItems.length === 0) {
      await fetchAllReport();
      return;
    }
    const data = selectedItems.map((item) => ({
      "تاریخ و ساعت": item.date || "",
      "شماره حواله": item.cargo_code || "",
      "پیمانکار": item.peymankar?.name || "",
      "پروژه": item.project?.title || "",
      "محل استقرار": item.location?.name || "",
      "دستگاه": item.machine?.name || "",
      "نوع دستگاه": item.machine?.type || "",
      "شیفت": item.shift?.name || "",
      "نقص فنی": item.defect?.name || "",
      "تاخیر": item.delays?.name || "",
      "تراز": item.balance || "",
      "راننده": item.driver?.name || "",
      "مدت زمان عملیات": item.duration || "",
      "کرایه": item.amount_with || "",
      "هزینه کل عملیات": item.sum_amount_with || "",
      "کالا": (item.jens || [])
        .map(
          (subItem, index) =>
            `کالا: ${subItem['defination']?.['title'] || 'نامشخص'}، کد کالا: ${
              subItem['jens_code']?.['title'] || 'نامشخص'
            }، تعداد: ${subItem['jens_unit'] || 'نامشخص'}، شماره کالا: ${
              subItem['jens_number'] || 'نامشخص'
            }، واحد: ${subItem['weight']?.['title'] || 'نامشخص'}، وزن: ${
              subItem['weight_unit'] || 'نامشخص'
            }`
        )
        .join("\n"),
      "مبدا": item.origin?.title || "",
      "مقصد": item.destination?.title || "",
      "تجهیز بارگیری": item.equipment?.name || "",
      "اپراتور": item.operator?.name || "",
      "نام مسئول عملیات": item.user?.name || ""
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Bargo');
    XLSX.writeFile(workbook, 'گزارشات-بارگو.xlsx');
  };

  const generatePDF = async () => {
    const parsedPayload = JSON.stringify(payload);
    const token = Cookies.get('login_token');

    try {
      setLoadingExportPdf(true)
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/ReportWeb/Reports/all`,
        parsedPayload,
        {
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      const datas = response.data.data.map((item) => ({
        id: item.id || 0,
        position: item.position || "",
        date: item.date || "",
        cargo_code: item.cargo_code || "",
        peymankar: { name: item.peymankar?.name || "" },
        project: { title: item.project?.title || "" },
        location: { name: item.location?.name || "" },
        machine: { name: item.machine?.name || "", type: item.machine?.type || "" },
        driver: { name: item.driver?.name || "" },
        duration: item.duration || "",
        amount_with: item.amount_with || "",
        sum_amount_with: item.sum_amount_with || "",
        jens: item.jens || [],
        shift: { name: item.shift?.name || "" },
        defect: { name: item.defect?.name || "" },
        delays: { name: item.delays?.name || "" },
        balance: item.balance || "",
        origin: { title: item.origin?.title || "" },
        destination: { title: item.destination?.title || "" },
        equipment: { name: item.equipment?.name || "" },
        operator: { name: item.operator?.name || "" },
        user: { name: item.user?.name || "" },
      }));
      const blob = await pdf(<PdfPage data={datas} />).toBlob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "bargo-report.pdf";
      link.click();
      setLoadingExportPdf(false)

      return response.data;
    } catch (error) {
      setLoadingExportPdf(false)
      throw error;
    }
  };

  const handleNavigateToMap = (lat, long) => {
    navigate('/reports/lists/map', { state: { lat, long } });
  };

  const handleNavigateToImages = (id) => {
    navigate('/reports/lists/images', { state: { id } });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('آیا میخواهید این گزارش حذف شود؟')) {
      return;
    }
    try {
      await deleteCargo({ id });
      toast.success('با موفقیت حذف شد!');
      window.location.reload();
    } catch (e) {
      toast.error('خطا در حذف گزارش!');
    }
  };

  const columns = [
    {
      title: 'تاریخ و ساعت',
      dataIndex: 'date',
      key: 'date',
      sorter: (a, b) => {
        if (!a.date && !b.date) return 0;
        if (!a.date) return 1;
        if (!b.date) return -1;
        return new Date(a.date) - new Date(b.date);
      },
      render: (text) => text ? <Text dir="ltr">{text}</Text> : <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'شماره حواله',
      dataIndex: 'cargo_code',
      key: 'cargo_code',
      sorter: (a, b) => {
        const aCode = a.cargo_code || '';
        const bCode = b.cargo_code || '';
        return aCode.localeCompare(bCode);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'پیمانکار',
      dataIndex: ['peymankar', 'name'],
      key: 'peymankar',
      sorter: (a, b) => {
        const aName = a.peymankar?.name || '';
        const bName = b.peymankar?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text ? <Text strong>{text}</Text> : <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'پروژه',
      dataIndex: ['project', 'title'],
      key: 'project',
      sorter: (a, b) => {
        const aTitle = a.project?.title || '';
        const bTitle = b.project?.title || '';
        return aTitle.localeCompare(bTitle);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'محل استقرار',
      dataIndex: ['location', 'name'],
      key: 'location',
      sorter: (a, b) => {
        const aName = a.location?.name || '';
        const bName = b.location?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'دستگاه',
      dataIndex: ['machine', 'name'],
      key: 'machine',
      sorter: (a, b) => {
        const aName = a.machine?.name || '';
        const bName = b.machine?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'پلاک',
      key: 'pelak',
      render: (_, record) => <PelakComponent pelak={record.machine?.pelak} />,
    },
    {
      title: 'نوع دستگاه',
      dataIndex: ['machine', 'type'],
      key: 'machineType',
      sorter: (a, b) => {
        const aType = a.machine?.type || '';
        const bType = b.machine?.type || '';
        return aType.localeCompare(bType);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'شیفت',
      dataIndex: ['shift', 'name'],
      key: 'shift',
      sorter: (a, b) => {
        const aName = a.shift?.name || '';
        const bName = b.shift?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'تاخیر',
      dataIndex: ['delays', 'name'],
      key: 'delays',
      sorter: (a, b) => {
        const aName = a.delays?.name || '';
        const bName = b.delays?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'نقص فنی',
      dataIndex: ['defect', 'name'],
      key: 'defect',
      sorter: (a, b) => {
        const aName = a.defect?.name || '';
        const bName = b.defect?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'تراز',
      dataIndex: 'balance',
      key: 'balance',
      sorter: (a, b) => {
        const aBalance = a.balance || 0;
        const bBalance = b.balance || 0;
        return aBalance - bBalance;
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'راننده',
      dataIndex: ['driver', 'name'],
      key: 'driver',
      sorter: (a, b) => {
        const aName = a.driver?.name || '';
        const bName = b.driver?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'مدت زمان عملیات',
      dataIndex: 'duration',
      key: 'duration',
      sorter: (a, b) => {
        const aDuration = a.duration || '';
        const bDuration = b.duration || '';
        return aDuration.localeCompare(bDuration);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'کرایه',
      dataIndex: 'amount_with',
      key: 'amount_with',
      sorter: (a, b) => {
        const aAmount = a.amount_with || 0;
        const bAmount = b.amount_with || 0;
        return aAmount - bAmount;
      },
      render: (text) => text ? `${text} تومان` : <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'هزینه کل عملیات',
      dataIndex: 'sum_amount_with',
      key: 'sum_amount_with',
      sorter: (a, b) => {
        const aAmount = a.sum_amount_with || 0;
        const bAmount = b.sum_amount_with || 0;
        return aAmount - bAmount;
      },
      render: (text) => text ? `${text} تومان` : <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'کالا',
      key: 'jens',
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          onClick={() => handleOpenModal(record.jens || [])}
        >
          نمایش کالا
        </Button>
      ),
    },
    {
      title: 'مبدا',
      dataIndex: ['origin', 'title'],
      key: 'origin',
      sorter: (a, b) => {
        const aTitle = a.origin?.title || '';
        const bTitle = b.origin?.title || '';
        return aTitle.localeCompare(bTitle);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'مقصد',
      dataIndex: ['destination', 'title'],
      key: 'destination',
      sorter: (a, b) => {
        const aTitle = a.destination?.title || '';
        const bTitle = b.destination?.title || '';
        return aTitle.localeCompare(bTitle);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'تجهیز بارگیری',
      dataIndex: ['equipment', 'name'],
      key: 'equipment',
      sorter: (a, b) => {
        const aName = a.equipment?.name || '';
        const bName = b.equipment?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'اپراتور',
      dataIndex: ['operator', 'name'],
      key: 'operator',
      sorter: (a, b) => {
        const aName = a.operator?.name || '';
        const bName = b.operator?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'نام مسئول عملیات',
      dataIndex: ['user', 'name'],
      key: 'user',
      sorter: (a, b) => {
        const aName = a.user?.name || '';
        const bName = b.user?.name || '';
        return aName.localeCompare(bName);
      },
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'عملیات',
      dataIndex: 'type',
      key: 'type',
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'توضیحات',
      dataIndex: 'desc',
      key: 'desc',
      render: (text) => text || <Text type="secondary">ثبت نشده</Text>,
    },
    {
      title: 'نوع گزارش',
      key: 'isWeightBridge',
      render: (_, record) => (
        <Text type={record.isWeightBridge === 1 ? "success" : "primary"}>
          {record.isWeightBridge === 1 ? 'باسکول' : 'بارگو'}
        </Text>
      ),
    },
    {
      title: 'وضعیت',
      key: 'kartabl_status',
      render: (_, record) => (
        <Text type={record.kartabl_status === 1 ? "warning" : "success"}>
          {record.kartabl_status === 1 ? 'درانتظار تایید' : 'تایید شده'}
        </Text>
      ),
    },
    {
      title: 'تصاویر',
      key: 'images',
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          disabled={record.isWeightBridge === 1}
          icon={<EyeOutlined />}
          onClick={() => handleNavigateToImages(record.id)}
        >
          نمایش تصاویر
        </Button>
      ),
    },
    {
      title: 'موقعیت',
      key: 'position',
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          disabled={record.isWeightBridge === 1}
          icon={<EnvironmentOutlined />}
          onClick={() => handleNavigateToMap(record.position?.latitude, record.position?.longitude)}
        >
          موقعیت بر روی نقشه
        </Button>
      ),
    },
    {
      title: 'عملیات',
      key: 'actions',
      fixed: 'right',
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => navigate(`/cargos/edit/${record.id}`)}
          >
            ویرایش
          </Button>
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          >
            حذف
          </Button>
        </Space>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedItems(selectedRows);
    },
  };

  return (
    <div>
      <CustomLoader isLoading={loading} />
      <DashboardLayout>
        <Space className="mb-4">
          {selectedItems.length > 0 ? (
            <PDFDownloadLink
              document={<PdfPage data={selectedItems} />}
              fileName="bargo-report.pdf"
            >
              <Button type="primary" icon={<FilePdfOutlined />}>
                خروجی پی دی اف (انتخابی)
              </Button>
            </PDFDownloadLink>
          ) : (
            <Button
              type="primary"
              onClick={generatePDF}
              loading={loadingExportPdf}
              icon={<FilePdfOutlined />}
            >
              {loadingExportPdf ? "درحال دریافت گزارش..." : "خروجی پی دی اف (همه)"}
            </Button>
          )}
          <Button
            type="default"
            onClick={exportToExcel}
            loading={loadingExport}
            icon={<FileExcelOutlined />}
          >
            {loadingExport ? "درحال دریافت گزارش..." : "خروجی اکسل"}
          </Button>
        </Space>

        {loading ? (
          <div className="mt-5">
            <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} />
          </div>
        ) : (
          <Table
            dataSource={reportData}
            columns={columns}
            loading={loading}
            rowKey="id"
            pagination={false}
            rowSelection={rowSelection}
            scroll={{ x: 'max-content' }}
            className="mt-5"
          />
        )}

        {paging.length > 1 && <Paginate links={paging} />}

        <Modal
          title="لیست کالا"
          open={isModalOpen}
          onCancel={handleCloseModal}
          footer={[
            <Button key="close" onClick={handleCloseModal}>
              بستن
            </Button>,
          ]}
          width={1000}
        >
          <Row gutter={[16, 16]}>
            {selectedJens.map((subItem, index) => (
              <Col xs={24} sm={12} md={8} key={index}>
                <Card size="small" className="shadow-md">
                  <p><strong>کالا:</strong> {subItem["jens"]?.["title"]}</p>
                  <p><strong>کد کالا:</strong> {subItem["jens_code"]?.["title"]}</p>
                  <p><strong>تعداد:</strong> {subItem["jens_unit"]}</p>
                  <p><strong>شماره کالا:</strong> {subItem["jens_number"]}</p>
                  <p><strong>واحد:</strong> {subItem["weight"]?.["title"]}</p>
                  <p><strong>وزن:</strong> {subItem["weight_unit"]}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Modal>
      </DashboardLayout>
    </div>
  );
}
